export const apiRoutes = {
  betaRegistrations: '/api/v1/beta-registrations',
  adminBeta: '/api/v1/admin/beta',
  toneAnalysis: '/api/v1/tone-analysis',
  videoPreview: '/api/v1/video-preview',
  songsSearch: '/api/v1/songs/search',
  songToneSignature: (id: string) => `/api/v1/songs/${encodeURIComponent(id)}/tone-signature`,
  songToneRecipe: (id: string) => `/api/v1/songs/${encodeURIComponent(id)}/tone-recipe`,
} as const
